import { AdCallResolver, AdUnit, ResolvedAdUnit } from '@mp-commons/modules/ads/AdUnit.js';
import { ComposableResolver } from '@mp-commons/modules/ads/adcall/ComposableResolver.js';
import { UserAdsData } from "@mp-commons/modules/ads/adcall/composable/UserAdsData.js";
import { RandomReplacer } from "@mp-commons/modules/ads/adcall/composable/CommonFiltersAndReplacers.js";
import { ExternallyPassedContentAdData, ContentSpecificAdData } from "@mp-commons/modules/ads/adcall/composable/ContentSpecificAdCallFilter.js";
import { UTMAdCallFilter } from "@mp-commons/modules/ads/adcall/composable/UTMAdCallFilter.js";
import { AdPlacementFilter } from "@mp-commons/modules/ads/adcall/composable/AdPlacementFilter.js";
import { getTestCallFilter } from "@mp-commons/modules/ads/adcall/composable/TestAdCallFilter.js";
import { AdCallParams } from '@mp-commons/modules/ads/AdCallParams.js';
import { VideoPolicyRules } from '@mp-commons/modules/ads/vprules/VideoPolicyRules.js';
import { VideoInfoRawData } from '@mp-commons/model/video/VideoInfo.js';
import { UserGestureUnmuter } from '@mp-commons/modules/unmuter/UserGestureUnmuter.js';
import { IMAUnmuter } from '@mp-commons/modules/unmuter/IMAUserGestureUnmuter.js';


/**
 * Builds an AdCallResolver function by composing multiple ad call parameter filters and replacers.
 *
 * @param window - The browser window object, used for context-specific filtering.
 * @param videoPolicy - Rules governing video ad policies.
 * @param contentSpecificAdData - Data specific to the content for ad targeting.
 * @param unmuter - Optional user gesture unmuter for ad playback.
 * @param imaUnmuter - Optional IMA SDK unmuter for ad playback.
 * @param extdata - Optional externally passed ad data for content.
 * @param ud - Optional user ads data for additional targeting.
 * @param enableTestAdCallParam - Optional flag to enable test ad call parameters.
 * @returns An AdCallResolver function that applies the composed filters and replacers to resolve ad units.
 */
export function ResolverBuilder(window: Window,
    videoPolicy: VideoPolicyRules,
    contentSpecificAdData: ContentSpecificAdData,
    unmuter?: UserGestureUnmuter,
    imaUnmuter?: IMAUnmuter,
    extdata?: ExternallyPassedContentAdData,
    // detected?: DetectedWebView,
    ud?: UserAdsData,
    enableTestAdCallParam?: boolean
): AdCallResolver {

    const composable = new ComposableResolver();
    composable.registerReplacer(RandomReplacer);
    composable.addParamsFilter(contentSpecificAdData, 1);
    composable.addParamsFilter(ud, 5);
    composable.addParamsFilter(new UTMAdCallFilter(window), 6);
    composable.addParamsFilter(getTestCallFilter(enableTestAdCallParam ? enableTestAdCallParam : false), 9);
    composable.addParamsFilter(new AdPlacementFilter(videoPolicy, extdata?.embedType,unmuter, imaUnmuter));

    return function (u: AdUnit, info: VideoInfoRawData, startingParams: AdCallParams): ResolvedAdUnit {
        return composable.resolver(u, info, startingParams);
    }



}